import { render, staticRenderFns } from "./UserManagement.vue?vue&type=template&id=363634da&scoped=true"
import script from "./UserManagement.vue?vue&type=script&lang=js"
export * from "./UserManagement.vue?vue&type=script&lang=js"
import style0 from "./UserManagement.vue?vue&type=style&index=0&id=363634da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363634da",
  null
  
)

export default component.exports